import React, { useEffect, useState } from 'react';
import './FormConversationFilter.css';
import Form from '/src/components/form/Form';
import Field from '/src/components/UI/Field/Field';
import Button from "/src/components/UI/Button/Button";
import TextInput from '/src/components/UI/TextField/TextInput';
import TextInputTime from '/src/components/UI/TextField/TextInputTime';
import { useForm } from 'react-hook-form';
import Dropdown from '/src/components/UI/DropDown/DropDown';
import channelsType from '/src/data/dropdown/channelsType'
import botJobTypes from '../../../data/types/botJobTypes';
import botService from '/src/features/bot/services/botService';
import channelTypeConversation from '../../../data/types/channelTypeConversation'
import ListMarkers from '../ListMarkers/ListMarkers';
import { setStorageParamForCurrentCompany, getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';
import InputDate from '/src/components/UI/InputDate/InputDate';
const FormConversationFilter = ({ title, onCloseModal, postbackAction, mode }) => {
    const { getBots } = botService;

    const [dataLocal, setDataLocal] = useState(getStorageParamForCurrentCompany('conversation_filters')); // un state surtout pour actualiser visuellement les dropdown quand on refresh
    const [bots, setBots] = useState("");
    const [selectedDates, setSelectedDates] = useState(dataLocal?.dates ?? null);
    const [resetMarkers, setResetMarkers] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const defaultValues = {
        bot_id: "", channel_type_id: "", markers: "",
        dates: "", conversation_id: "", text_content: "",
        caller: "", numbers: "", calldata: "", url: "", body: "",
        bot_job_id: "", bot_job_type_id: "", start_time: "", end_time: "",
    }

    const { register, handleSubmit, formState: { errors }, formState, getValues, setValue, watch } = useForm({
        mode: "onChange",
        defaultValues: {
            bot_id: dataLocal ? dataLocal.bot_id : -1,
            channel_type_id: dataLocal ? dataLocal.channel_type_id : -1,
            markers: dataLocal ? dataLocal.markers : "",
            dates: dataLocal ? dataLocal.dates : "",
            conversation_id: dataLocal ? dataLocal.conversation_id : "",
            bot_job_id: dataLocal ? dataLocal.bot_job_id : "",
            text_content: dataLocal ? dataLocal.text_content : "",
            caller: dataLocal ? dataLocal.caller : "",
            numbers: dataLocal ? dataLocal.numbers : "",
            calldata: dataLocal ? dataLocal.calldata : "",
            url: dataLocal ? dataLocal.url : "",
            body: dataLocal ? dataLocal.body : "",
            start_time: dataLocal ? dataLocal.start_time : "",
            end_time: dataLocal ? dataLocal.end_time : ""
        }
    });


    const cleanStorage = () => {
        setStorageParamForCurrentCompany('conversation_filters', {})
        setSelectedDates(null);
        for (let fieldName in defaultValues) {
            setValue(fieldName, defaultValues[fieldName]);
        }
        setDataLocal(defaultValues)
        setResetMarkers(!resetMarkers)
    }

    const updateMarkersValues = (selectedMarkersList, resultList) => {
        setValue("markers", selectedMarkersList);
    };

    const checkEmptyDropdownValue = (data, label) => {

        let value = data[label]
        if (value == "" || value == -1) { // si rien selectionner ou alors le choix par default 
            value = value == -1 ? "" : (dataLocal ? dataLocal[label] : ""); //au cas ou on ne selectionne rien dans la dropdown
        }
        return value;
    }
    const onSubmit = () => {
        let data = getValues();
        data.bot_id = checkEmptyDropdownValue(data, 'bot_id');

        data.channel_type_id = checkEmptyDropdownValue(data, 'channel_type_id');
        //data.date = selectedDates;
        let dataToSend = data;
        if (mode == 2) {
            dataToSend.bot_job_type_id = dataToSend.channel_type_id;
        }

        const noEmptyValues = Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== null && value !== "" && value !== undefined));

        setStorageParamForCurrentCompany('conversation_filters', noEmptyValues);
        postbackAction(noEmptyValues);
        onCloseModal();
    };


    const setUpBots = (_bots) => {
        const bots = _bots || [];
        const initialOption = { value: '-1', text: 'Choose bot' };
        const sortedBots = bots.sort((a, b) => a.name.localeCompare(b.name));
        return [
            initialOption,
            ...sortedBots.map(bot => ({
                value: bot.id,
                text:
                    <span style={{ maxWidth: "300px" }}>
                        <i style={{ marginRight: '15px' }} className={'flag-icon flag-icon-' + bot.language.slug.toLowerCase()}></i>
                        <div className="conversation_content_dropdown">{bot.name}</div>
                    </span>
            }))
        ]
    }

    let listChannelChoice = [{ value: '-1', text: 'Choose channel' }, ...(mode != "2" ? channelTypeConversation : botJobTypes)]

    const getAllBots = async () => {
        let [response, error] = await getBots();
        if (error !== null) {
            console.log(error);
            return;
        }
        setValue("bot", "")
        setBots(setUpBots(response));
    }

    useEffect(() => {
        getAllBots();
    }, [])

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Title>{title}</Form.Title>
            <Form.Body className={(mode == 0 || mode == 1) && "conversation_form_filter_body"}>
                <div className='content_form_filter_conversation'>

                    <div className="conversation_filter_dropdown_container">
                        <Field label="Channel" listLabelClassName="field-modal" />
                        <div>
                            {channelsType?.length > 0 && // la valeur par default existe OBLIGATOIREMENT sinon la liste serait vide donc pas affichee
                                <Dropdown name="channel_type_id" setValue={setValue} choices={listChannelChoice} defaultChoice={dataLocal ? dataLocal.channel_type_id : channelsType[0]?.id} width="200px"></Dropdown>
                            }
                        </div>
                    </div>
                    <div className="conversation_filter_dropdown_container">
                        <Field label="Bot" listLabelClassName="field-modal" />
                        <div>
                            {bots?.length > 0 && // la valeur par default existe OBLIGATOIREMENT sinon la liste serait vide donc pas affichee
                                <Dropdown name="bot_id" setValue={setValue} choices={bots} defaultChoice={dataLocal ? dataLocal.bot_id : bots[0]?.id} width="200px" />
                            }
                        </div>
                    </div>
                    <div className={"conversation_filter_input_container"}>
                        <Field label="ID" listLabelClassName={"field-modal"} />
                        <TextInput {...register(mode == 2 ? "bot_job_id" : "conversation_id")} placeholder="Enter the conversation id" className="input full-width"></TextInput>
                    </div>
                    {
                        (mode == 0 || mode == 1) &&
                        <>
                            {mode == 0 &&
                                <div className={"conversation_filter_input_container"}>
                                    <Field label="Days" listLabelClassName={"field-modal"} />
                                    <InputDate className="conversation_input_date" dates={selectedDates} setValue={(_dates) => { setValue("dates", _dates); setSelectedDates(_dates) }} removeSeparator={true} />
                                </div>
                            }

                            {mode == 0 && selectedDates && (
                                <div className="conversation_filter_input_container">
                                    <Field label="Time" listLabelClassName="field-modal" />
                                    <div className="conversation_container_time-inputs">
                                        <TextInputTime {...register("start_time")} onChange={(e) => setStartTime(e.target.value)} placeholder="Start Time" />
                                        <span>to</span>
                                        <TextInputTime {...register("end_time")} onChange={(e) => setEndTime(e.target.value)} placeholder="End Time" />
                                    </div>
                                </div>
                            )}
                            <div className={"conversation_filter_input_container"}>
                                <Field label="Text Content" listLabelClassName={"field-modal"} />
                                <TextInput {...register("text_content")} placeholder="Enter the content text" className="input full-width"></TextInput>
                            </div>

                            {watch("channel_type_id") !== 1 && (
                                <>
                                    <div className={"conversation_filter_input_container"}>
                                        <Field label="Caller" listLabelClassName={"field-modal"} />
                                        <TextInput {...register("caller")} placeholder="Enter the phone number" className="input full-width"></TextInput>
                                    </div>
                                    <div className={"conversation_filter_input_container"}>
                                        <Field label="Called" listLabelClassName={"field-modal"} />
                                        <TextInput {...register("numbers")} placeholder="Enter the phone number" className="input full-width"></TextInput>
                                    </div>
                                </>
                            )}
                        </>
                    }
                    {
                        mode == 2 ?
                            <>
                                <div className={"conversation_filter_input_container"}>
                                    <Field label="Url" listLabelClassName={"field-modal"} />
                                    <TextInput {...register("url")} placeholder="Enter the url" className="input full-width"></TextInput>
                                </div>
                                <div className={"conversation_filter_input_container"}>
                                    <Field label="Body" listLabelClassName={"field-modal"} />
                                    <TextInput {...register("body")} placeholder="Enter the body content" className="input full-width"></TextInput>
                                </div>
                            </>
                            :
                            <>
                                <div className={"conversation_filter_input_container"}>
                                    <Field label="Data" listLabelClassName={"field-modal"} />
                                    <TextInput {...register("calldata")} placeholder="Enter the data" className="input full-width"></TextInput>
                                </div>
                                <div className={"conversation_filter_input_container"}>
                                    <Field label="Markers" listLabelClassName={"field-modal"} />
                                    <ListMarkers updateMarkersValues={updateMarkersValues} resetMarkers={resetMarkers} />
                                </div>
                            </>
                    }
                </div>
            </Form.Body>
            <Form.Buttons className="form_conversation_filter_space_button">
                <Button type="button" label="Reset Filter" className="button cancel" onClick={cleanStorage}></Button>
                <Button type="submit" label="Ok" className="validate  btn-center" disabled={!formState.isValid} />
            </Form.Buttons>
        </Form >
    );
};

export default FormConversationFilter;